import { select, delay, race, take } from "redux-saga/effects";

/**
 * Waits for a specific state condition to be met within a timeout period.
 * @param selector
 * @param predicate
 * @param timeoutMs
 * @param intervalMs
 * @returns
 */
export function* waitForState<T>(
  selector: (state: any) => T,
  predicate: (value: T) => boolean,
  timeoutMs = 1000,
  intervalMs = 20,
): Generator<any, T | undefined, any> {
  let elapsed = 0;
  while (elapsed <= timeoutMs) {
    const value: T = yield select(selector);
    if (predicate(value)) return value;
    yield delay(intervalMs);
    elapsed += intervalMs;
  }
  return undefined;
}

/**
 * Waits for a specific state value to equal the expected value within a timeout period.
 * @param selector
 * @param expectedValue
 * @param timeoutMs
 * @param intervalMs
 * @returns
 */
export function* waitForActions(
  actionTypes: string | string[],
  timeoutMs = 1000,
): Generator<any, any, any> {
  const types = Array.isArray(actionTypes) ? actionTypes : [actionTypes];
  const result = yield race({
    action: take(types),
    timeout: delay(timeoutMs),
  });
  if (result?.action) return result.action;
  return undefined;
}
